module.exports = __webpack_public_path__ + "static/media/onsoc_medium.6f19a31f.jpg";